'use strict';

var _classCallCheck = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var Base =
/*#__PURE__*/
function () {
  function Base(name, code, implementation, alphabet) {
    _classCallCheck(this, Base);

    this.name = name;
    this.code = code;
    this.codeBuf = Buffer.from(this.code);
    this.alphabet = alphabet;
    this.engine = implementation(alphabet);
  }

  _createClass(Base, [{
    key: "encode",
    value: function encode(buf) {
      return this.engine.encode(buf);
    }
  }, {
    key: "decode",
    value: function decode(string) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = string[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var char = _step.value;

          if (this.alphabet && this.alphabet.indexOf(char) < 0) {
            throw new Error("invalid character '".concat(char, "' in '").concat(string, "'"));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.engine.decode(string);
    }
  }]);

  return Base;
}();

module.exports = Base;